import { ReactElement } from 'react';
import Tooltip from '@app/common/Tooltip/Tooltip';
import Lang from '@lang/en';
import {
  ClockIcon,
  DocumentIcon,
  EditPenIcon,
  HashIcon,
  HealthIconNew,
} from '@assets/images';
import { OrderDetailsI } from '@app/healthcheck/order/types';
import {
  CardStyled,
  StyledContent,
  StyledHeader,
  StyledParagraph,
  WrapHeader,
} from '../styles';
import {
  applyEllipsis,
  dateTime24FriendlyFormatWithComma,
  formatUTCStringAsApiTimestamp,
} from '@app/utils';
import { getTestTypeLabel } from '@root/src/app/healthcheck/ordersTable/utils';
import Button from '@designSystem/buttons/index';

interface OrderProps {
  data: OrderDetailsI;
  handleEditOpenOrder: () => void;
  isOrderStatusDone?: boolean;
}

const OrderDetails = ({
  handleEditOpenOrder,
  data,
  isOrderStatusDone,
}: OrderProps): ReactElement => {
  const bookedDate = formatUTCStringAsApiTimestamp(
    data.bookedDate,
    dateTime24FriendlyFormatWithComma
  );

  return (
    <CardStyled>
      <WrapHeader>
        <StyledHeader>{Lang.healthCheckDetailsOrderCard}</StyledHeader>
        {!isOrderStatusDone && (
          <Button
            data-testid="healthcheck-order-edit-order-button"
            type="tertiary"
            label={Lang.editText}
            icon={<EditPenIcon />}
            onClick={handleEditOpenOrder}
          />
        )}
      </WrapHeader>
      <StyledContent>
        <Tooltip
          textTooltip={Lang.healthCheckOrderTestTypeTool}
          followingTooltip={true}
          position="bottom-start"
          arrow={false}
          theme="testedme_dark"
        >
          <StyledParagraph data-testid="healthcheck-order-details-testType">
            <HealthIconNew />
            {getTestTypeLabel(data.testType, data.testCategory)}
          </StyledParagraph>
        </Tooltip>
        <Tooltip
          textTooltip={Lang.healthCheckOrderTimeTool}
          followingTooltip={true}
          position="bottom-start"
          arrow={false}
          theme="testedme_dark"
        >
          <StyledParagraph data-testid="healthcheck-order-details-bookedDate">
            <ClockIcon />
            {bookedDate}
          </StyledParagraph>
        </Tooltip>
        <Tooltip
          textTooltip={Lang.healthCheckEditOrderOtherRefNumberLabel}
          followingTooltip={true}
          position="bottom-start"
          arrow={false}
          theme="testedme_dark"
        >
          <StyledParagraph data-testid="healthcheck-order-details-referenceCode">
            <DocumentIcon />
            {data.referenceCode}
          </StyledParagraph>
        </Tooltip>
        <Tooltip
          textTooltip={Lang.healthCheckEditOrderOtherBarcodeNumberLabel}
          followingTooltip={true}
          position="bottom-start"
          arrow={false}
          theme="testedme_dark"
        >
          <StyledParagraph data-testid="healthcheck-order-details-barcodeNumber">
            <HashIcon />
            {applyEllipsis(String(data.barcodeNumber || ''), 19)}
          </StyledParagraph>
        </Tooltip>
      </StyledContent>
    </CardStyled>
  );
};

export default OrderDetails;
